export default {
	loading: {
		partIsLoading: "Chargement de la pièce...",
		partIsSaving: "Enregistrement de la pièce...",
		anchorFaceIsChanging: "Changement du côté supérieur...",
		featureIsSetting: "Application de la fonctionnalité...",
		whileMarkingFeaturesMessage: "Marquage des fonctionnalités...",
		imageAlt: "Chargement...",
	},
	errors: {
		modelCannotBeShown: "Le modèle ne peut pas être affiché. Veuillez contacter notre service d'assistance.",
		saveFailedTitle: "Erreur lors de l'enregistrement",
		changeCouldNotBeMade:
			"La modification n'a pas pu être effectuée. Veuillez contacter notre service d'assistance.",
		messageCouldNotBeConfirmed: "Le message n'a pas pu être confirmé.",
		weldlineDefinitionError:
			"Erreur lors de la définition des cordons de soudure. Veuillez contacter info@blexon.com",
		modificationFailedShortDescription:
			"La modification souhaitée du modèle n'a pas pu être terminée. " +
			"Veuillez envoyer l'article à notre service d'assistance pour une vérification gratuite.",
		featureCreationFailedTitle: "La fonctionnalité n'a pas pu être créée",
		editingErrorTitle: "Erreur lors de la modification",
		modelEditingFailedTitle: "Erreur lors de la modification du modèle",
		rollDirectionAdjustFailedTitle: "Le sens de laminage n'a pas pu être ajusté",
		rollDirectionAngleAdjustFailedTitle: "L'angle du sens de laminage n'a pas pu être ajusté",
		rollDirectionSetFailed:
			"Le sens de laminage n'a pas pu être défini. Veuillez utiliser une ligne sur un contour " +
			"extérieur ou une découpe.",
	},
	devMode: "DEV-MODE",
	panels: {
		editor: "Éditeur",
		mode: "Mode",
		article: "Article",
		messages: "Messages",
		features: "Fonctionnalités",
		structure: "Structure",
	},
	processType: {
		cut: "Découpe",
		cylindicBend: "Pliage",
		engrave: "Gravure",
		formCountersink: "Lamage",
		formExtrudedThread: "Filetage extrudé",
		formScrewThread: "Formage de filet",
		weld: "Soudage",
		drillCylinderHeadBoltHole: "Lamage pour vis à tête cylindrique",
		pressJoin: "Insert pressé",
		none: "Aucun processus",
		unknown: "Processus inconnu",
	},
	editorMode: {
		featureMode: "Édition",
		measuringMode: "Mesure",
		rollDirectionMode: "Sens de laminage",
		weldMode: "Soudage",
		none: "Aucun mode",
	},
	featureType: {
		undefined: "Non défini",
		anchorFace: "Côté supérieur",
		bottomFace: "Côté inférieur",
		sideFace: "Côté extérieur",
		bend: "Ligne de pliage",
		hole: "Trou rond",
		cutout: "Découpe",
		screwThread: "Filetage",
		countersink: "Lamage",
		extrudedThread: "Collerette extrudée",
		engraving: "Gravure",
		invalid: "Non valide",
		weldline: "Cordon de soudure",
		cylinderHeadBoltHole: "Cordon de soudure",
		pressJoin: "Insert pressé",
		unknown: "Fonctionnalité inconnue",
	},
};
